import React from "react";
//Components
import Button from "components/shared/Button";
import { platforms } from "./Platforms";

function DialogActionWithInstructions(props) {
    return (
        <div>
            <div>
                <p>برای نصب این برنامه :</p>
                <ul>
                    <li>
                        <span style={{ display: "flex", alignItems: "center" }}>{props.action1}</span>
                    </li>
                    <li>{props.action2}</li>
                </ul>
            </div>
            <div>
                <Button text="باشه!" onClickButton={props.onSubmit} cancelGray />
            </div>
        </div>
    );
}

export default function InstallDialogAction(props) {
    return (
        <>
            <div className="row flex-center my-15">
                {props.platform === platforms.NATIVE && (
                    <>
                        <Button className="mx-5" text="انصراف" onClickButton={props.onClose} cancelGray />
                        <Button className="mx-5" text="نصب" onClickButton={props.onSubmit} />
                    </>
                )}
                {props.platform === platforms.IDEVICE && (
                    <DialogActionWithInstructions
                        action1={
                            <>
                                روی دکمه share ضربه بزنید:
                                <i className="icon-notification" />
                            </>
                        }
                        action2="سپس 'Add to Homescreen' را پیدا کرده و روی آن ضربه بزنید"
                        onSubmit={props.onSubmit}
                    />
                )}
                {props.platform === platforms.FIREFOX && (
                    <DialogActionWithInstructions
                        action1={
                            <>
                                روی این آیکون در نوار آدرس ضربه بزنید:
                                <i className="icon-notification" />
                            </>
                        }
                        action2="سپس 'Add to Homescreen' روی  ضربه بزنید"
                        onSubmit={props.onSubmit}
                    />
                )}
                {props.platform === platforms.FIREFOX_NEW && (
                    <DialogActionWithInstructions
                        action1={
                            <>
                                روی دکمه منو ضربه بزنید:
                                <i className="icon-menu-burger" />
                            </>
                        }
                        action2="سپس 'Install' روی  ضربه بزنید"
                        onSubmit={props.onSubmit}
                    />
                )}
                {props.platform === platforms.OPERA && (
                    <DialogActionWithInstructions
                        action1={
                            <>
                                روی دکمه منو ضربه بزنید:
                                <i className="icon-menu-burger" />
                            </>
                        }
                        action2={
                            <>
                                سپس ضربه بزنید روی &nbsp;'
                                <i className="icon-notification" />
                                Home screen'
                            </>
                        }
                        onSubmit={props.onSubmit}
                    />
                )}
                {props.platform === platforms.OTHER && (
                    <div>
                        <div>متأسفانه ویژگی نصب توسط مرورگر شما پشتیبانی نمی شود.</div>
                        <div>
                            <Button text="باشه!" onClickButton={props.onClose} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
